<template>
  <div>
    <el-container class="container-role">
      <el-aside id="page">
        <el-card id="queryForm" :body-style="{padding: '10px 20px 10px 20px'}">
          <el-form :inline="true" size="small" :model="queryForm" ref="queryForm">
            <el-form-item label="编码：" prop="code">
              <el-input placeholder="编码模糊查询" v-model="queryForm.code"></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
              <el-input placeholder="名称模糊查询" v-model="queryForm.name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
              <el-button type="warning" icon="el-icon-refresh" @click="resetFun('queryForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <el-button-group>
          <el-button type="primary" icon="el-icon-refresh" size="small" @click="search">刷新</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addFun">新增</el-button>
          <el-button type="primary" icon="el-icon-edit" size="small" @click="editFun">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" @click="delFun">删除</el-button>
        </el-button-group>
        <el-table :data="tableData" ref="tableData" @current-change="selectRow" border size="small" stripe height="200" highlight-current-row v-loading="isLoading">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="code" label="编码" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination :current-page="pager.currentPage" :total="pager.total" :page-sizes="pager.pageSizes" @size-change="sizeChange" @current-change="currentChange" background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
      </el-aside>
      <el-main class="main-role">
        <el-button-group>
          <el-button type="primary" icon="el-icon-refresh" size="small" @click="getMenus">刷新</el-button>
          <el-button type="primary" icon="el-icon-caret-bottom" size="small" @click="expansionFun(menus, true)">展开</el-button>
          <el-button type="primary" icon="el-icon-caret-right" size="small" @click="expansionFun(menus, false)">折叠</el-button>
          <el-button type="primary" icon="el-icon-success" size="small" @click="setRoleMenu">保存</el-button>
        </el-button-group>
        <el-tree :data="menus" default-expand-all ref="menus" node-key="id" v-loading="isMenuLoading" :props="{label: 'name'}" show-checkbox class="menu-tree" :style="{height: menuHeight + 'px'}"></el-tree>
      </el-main>
    </el-container>
    <AddOrUpdate ref="addOrUpdate" :refresh="search"/>
  </div>
</template>

<script>
import AddOrUpdate from './AddOrUpdate'

export default {
  name: 'RoleList',
  components: {AddOrUpdate},
  data () {
    return {
      //加载层显示
      isLoading: false,
      //菜单树加载层
      isMenuLoading: false,
      //查询参数
      queryForm: {
        code: '',
        name: ''
      },
      //分页参数
      pager: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100]
      },
      //表格数据
      tableData: [],
      //当前选中行
      currentRow: null,
      //菜单树
      menus: [],
      //菜单树的高度（动态计算）
      menuHeight: 500
    }
  },
  methods: {
    //每页显示条数改变
    sizeChange: function (size){
      this.pager.pageSize = size
      this.search()
    },
    //当前页改变
    currentChange: function(current){
      this.pager.currentPage = current
      this.search()
    },
    //查询数据
    search: function () {
      this.isLoading = true
      //请求参数
      let params = [{
        field: 'code',
        type: 'like',
        value: this.queryForm.code
      }, {
        field: 'name',
        type: 'like',
        value: this.queryForm.name
      }]
      //请求分页数据
      this.$axios({
        method: 'post',
        url: '/sysRole/selectPage',
        data: {
          size: this.pager.pageSize,
          current: this.pager.currentPage,
          orderField: 'id',
          params: params
        },
      }).then(response => {
        this.isLoading = false
        this.pager.total = response.total
        this.tableData = response.rows
      }).catch(error => {
        this.isLoading = false
      })
    },
    //重置查询条件
    resetFun: function (formName) {
      this.$refs[formName].resetFields()
      this.search()
    },
    //选中行改变
    selectRow: function (currentRow) {
      //记录当前行数据
      this.currentRow = currentRow
      //查询对应角色的菜单并勾选
      if(currentRow){
        this.$axios.get('/sysMenu/getMenuIds', {
          params: { roleId: currentRow.id }
        }).then(response => {
          //筛选去掉非子节点的菜单(不然子节点会全部被选中)
          this.removeHasChildren(response, this.menus)
          //选中有权限的菜单
          this.$refs.menus.setCheckedKeys(response)
        })
      }
      else {
        this.$refs.menus.setCheckedKeys([])
      }
    },
    //新增
    addFun: function () {
      this.$refs.addOrUpdate.isDialog = true
      this.$refs.addOrUpdate.title = '新增'
    },
    //编辑
    editFun: function () {
      if (this.currentRow) {
        this.$refs.addOrUpdate.isDialog = true
        this.$refs.addOrUpdate.title = '编辑'
        this.$refs.addOrUpdate.role = JSON.parse(JSON.stringify(this.currentRow))
      } else {
        this.$message.info('请先选择需要编辑的数据！')
      }
    },
    //删除
    delFun: function () {
      if (this.currentRow) {
        //确认删除
        this.$confirm('确认删除当前选中数据？', '提示', {
          type: 'warning'
        }).then(() => {
          //删除数据
          this.$axios.get('/sysRole/delete', {
            params: {
              id: this.currentRow.id
            }
          }).then(response => {
            this.search()
            this.$message.success('删除成功~')
          })
        })
      } else {
        this.$message.info('请先选择需要删除的数据！')
      }
    },
    //菜单树
    getMenus: function(){
      this.isMenuLoading = true
      this.$axios.get('/sysMenu/getAll').then(response => {
        this.isMenuLoading = false
        this.menus = this.$utils.convertTree(response)
      }).catch(error => {
        this.isMenuLoading = false
      })
    },
    //全部展开或折叠
    expansionFun: function(data, isOpen){
      data.forEach(row => {
        if(row.children && row.children.length > 0){
          this.$refs.menus.store.nodesMap[row.id].expanded = isOpen
          this.expansionFun(row.children, isOpen)
        }
      })
    },
    //角色菜单权限设置
    setRoleMenu: function(){
      //判断是否选中角色
      if(!this.currentRow){
        this.$message.info('请先选择角色！')
        return
      }
      //获取被选中的节点key值(包含半选中的)
      let checkeds = this.$refs.menus.getCheckedKeys()
      let halfCheckeds = this.$refs.menus.getHalfCheckedKeys()
      if(halfCheckeds.length > 0){
        checkeds.push(halfCheckeds)
      }
      //数据提交保持
      this.$axios({
        method: 'post',
        url: '/sysRoleMenu/setRoleMenu',
        data: this.$qs.stringify({
          roleId: this.currentRow.id,
          menuIds: checkeds.join(',')
        })
      }).then(response => {
        this.$message.success('保存成功~')
      })
    },
    //移除数组中的有子节点的ID(选择角色时自动选中不需要处理父节点)
    removeHasChildren: function(menuIds, menus){
      //筛选去掉非子节点的菜单(不然子节点会全部被选中)
      menus.forEach(node => {
        //有子节点
        if(node.children && node.children.length > 0){
          //不勾选此节点(通过勾选子节点自动勾选)
          let pos = menuIds.indexOf(node.id)
          if(pos != -1){
            menuIds.splice(pos, 1)
          }
          //递归处理下级的子节点
          this.removeHasChildren(menuIds, node.children)
        }
      })
    }
  },
  mounted () {
    //加载完成后动态计算表格的高度
    this.$nextTick(() => {
      $('.el-table').css({
        height: $('#page').height() - $('#queryForm').height() - 95
      })
    })
    //查询表格数据
    this.search()
    //查询菜单树
    this.getMenus()
    //计算菜单树的高度
    this.menuHeight = $('.main-role').height() - 55
  }
}
</script>

<style scoped>
.container-role {
  margin: 0;
  height: 100%;
}

.menu-tree {
  overflow: auto;
  border: 2px solid #eaeaea;
}

.main-role {
  padding: 5px 10px 5px 10px;
}

#page {
  padding: 10px;
  height: 100%;
  width: 70% !important;
  border-right: 4px solid #eeeaea;
}

.el-form-item {
  margin-bottom: 10px;
  margin-top: 10px;
}

.el-button-group {
  margin: 8px 0 5px 0;
}

.el-pagination {
  text-align: right;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/role/RoleList.vue